import { Observable } from "rxjs";
import { Connection } from "../entities/connection.entity";

export abstract class ConnectionRepositoryPort {
  abstract getEntityConnections(): Observable<Connection[]>;
}
